import { AuthMe } from "@/Services/api/AuthService";

export default {
  // namespaced: true, // Add this if you're using namespaced modules
  state: {
    isAuthenticated: !!localStorage.getItem('accessToken'),
    userData:  null,
    accessToken: localStorage.getItem('accessToken'),
    userEmail: ''
  },
  getters: {
    isAuthenticated(state) {
      return state.isAuthenticated;
    },
    userData(state) {
      return state.userData;
    },
    accessToken(state) {
      return state.accessToken;
    },
    getUserEmail(state){
      return state.userEmail
    }
  },
  mutations: {
    setUserData(state, payload) { // Add `state` as the first argument
      state.userData = payload;
    },
    setAccessToken(state, payload) {
      state.accessToken = payload,
      localStorage.setItem('accessToken', payload);
    },
    setAuthenticated(state, payload) {
      state.isAuthenticated = payload
    },
    setUserEmail(state, payload){
      state.userEmail = payload
    }
  },
  actions: {
    async fetchUserData({state, commit }) {
      if(state.accessToken){
        const response = await AuthMe();
        commit('setUserData', response.data.data);
      }
    },
    
    logout({ commit }) {
      localStorage.removeItem('accessToken'); // Remove token from localStorage
      commit('setAuthenticated', false);
      commit('setUserData', null);
    },
  },
};
